export default class WechatAppElement {
    constructor(component) {
        this.boundingClientRect = () => {
            return new Promise(resolve => {
                this.component.boundingClientRect(rect => resolve(rect)).exec();
            });
        };
        this.component = component;
    }
}
